import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 从本地缓存中移除指定 key。
 * @param key 缓存key
 * @returns Promise<boolean>
 */
export const removeStorage = (key: string) => {
  return new Promise<boolean>((resolve, reject) => {
    core.call<'fabric_storage.removeStorage', string, boolean>(
      'fabric_storage.removeStorage',
      key,
      (result) => {
        const fabricErrors = filterFabricErrors(
          result.code,
          result.message,
          result.data
        );
        if (fabricErrors) {
          reject(fabricErrors);
        } else {
          resolve(result.data);
        }
      }
    );
  });
};
